import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BasePage } from '../../../shared/base.page';
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { UIService } from '../../../shared/services/UIService';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';  
import { CKEditorComponent } from 'ng2-ckeditor';
import { viewParentEl } from '@angular/core/src/view/util';

@Component({
    templateUrl: './holidays.page.html' 
})

export class HolidaysPage extends BasePage {

    @ViewChild("grid") grid: DxDataGridComponent;
    @ViewChild("frmReset") frmReset: DxValidationGroupComponent;  
    items: any[] = [
        {
            title: "Publish",
            name: "publish",
            icon: "icon-globe",
            showOnRow: false 
        },
        {
            title: "Add New",
            name: "addnew",
            icon: "icon-plus",
            showOnRow: false,
            class: "info",
        }
    ] 

    searchModel:any={CountryId:null,State:"---"};
    loadingVisible: boolean = false;
    popupLogVisible: boolean = false;
    popupEditVisible: boolean = false;
    popupEditVisible1: boolean = false;
    log: string = null;
    editRow: any = {};
    countries: any[] = [];   
    countries1: any[] = []; 
    PublishResult: any[] = [];
    months:any=Array.from(Array(12), (_, i) => (i+1)<10 ?'0'+(i+1).toString():(i+1).toString());
    days:any=Array.from(Array(31), (_, i) => (i+1)<10 ?'0'+(i+1).toString():(i+1).toString());
    states: any[] = ['ACT','NSW','NT','QLD','SA','TAS','VIC','WA'];
    states1: any[] =['---','ACT','NSW','NT','QLD','SA','TAS','VIC','WA'];
    constructor(public router: Router, serviceCaller: ServiceCaller, public uiService: UIService) {
        super(serviceCaller); 
        serviceCaller.get('/Country/List').then(c => { 
            this.countries1=c;
            this.countries1.unshift({Code:'---',ID:null});
            this.countries = c; 
        });  
    }


    onMenuItemClick(e) {
        switch (e.name) {
            case "addnew":
            {
                debugger 
                this.editRow={
                    CountryID:null,
                    IsNew:false,
                    State:null, 
                    Name:null,
                    HYear:null,
                    HMonth:null,
                    HDay:null,
                    Description:null
                }
                this.popupEditVisible = true;
                break;
            }
            case "DXEdit":
                {
                    e.handled = true;
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {  
                        Object.assign(this.editRow, this.grid.instance.getSelectedRowsData()[0]); 
                        this.editRow.IsNew=true;
                        this.popupEditVisible = true;
                    }
                    break;
                }
            case "publish":
                {
                    this.loadingVisible = true;
                    this.api.post("/Holiday/Publish").then(data => {
                        debugger
                        if (data) 
                        { 
                            this.PublishResult=data;
                            this.popupEditVisible1 = true; 
                        }
                        else
                        {
                            this.grid.instance.refresh();
                            this.uiService.success();
                        }
                        this.loadingVisible = false;
                    }).catch(e => {
                        this.loadingVisible = false;})
                    ;
                    break;
                }
        }
    }


    save() {
        if (this.frmReset.instance.validate().isValid) {
            this.loadingVisible = true;
            this.api.post("/Holiday/Save", this.editRow).then(() => {
                this.grid.instance.refresh(); 
                this.popupEditVisible = false;
                Object.assign(this.grid.instance.getSelectedRowsData()[0],this.editRow)
            }).catch(e => { }).then(c => {
                this.loadingVisible = false;
            });
        }

    }

    cancel()
    {
        this.popupEditVisible = false;  
    } 

    handleSourceChange() { 
        this.grid.instance.refresh();
    }

    monthChange(e)
    {
        if(["01","03","05","07","08","10","12"].includes(e))
            this.days=Array.from(Array(31), (_, i) => (i+1)<10 ?'0'+(i+1).toString():(i+1).toString());
        else    
            this.days=Array.from(Array(30), (_, i) => (i+1)<10 ?'0'+(i+1).toString():(i+1).toString());
    }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Settings/holidays.page.ts